import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["accessibilityLabel", "id", "size", "testID", "UNSAFE_svgProps"];
import React from 'react';
import Surface from '@bubble-ui/primitive-surface';
import Shape from '@bubble-ui/primitive-shape';
import Defs from '@bubble-ui/primitive-defs';
import LinearGradient from '@bubble-ui/primitive-linear-gradient';
import Stop from '@bubble-ui/primitive-stop';
import RadialGradient from '@bubble-ui/primitive-radial-gradient';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import { usePropsSpreadingDeprecationWarning } from '@bubble-ui/hook-use-props-spreading-deprecation-warning';
var ColoredIllustrationExperts = _ref => {
  var {
      accessibilityLabel,
      id,
      size = 100,
      testID,
      UNSAFE_svgProps
      /**
       * @deprecated props spreading is outdated and will be removed with v7.0.0
       */
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  usePropsSpreadingDeprecationWarning({
    componentName: 'ColoredIllustrationExperts',
    props,
    useInstead: 'UNSAFE_svgProps',
    removalDate: 'v7.0.0'
  });
  return /*#__PURE__*/React.createElement(Surface, _extends({
    id: id
  }, testID ? {
    testID
  } : {}, UNSAFE_svgProps, {
    accessibilityLabel: accessibilityLabel,
    fill: "none",
    viewBox: "0 0 100 100",
    width: size,
    height: size
  }, props), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint0_linear_5601_1318)",
    d: "M28.941 8.05c-1.88 0-3.41 1.53-3.41 3.41v76.95c0 1.88 1.53 3.41 3.41 3.41h43.83c1.88 0 3.41-1.53 3.41-3.41V11.46c0-1.88-1.53-3.41-3.41-3.41h-11.2l-4.48 5.84h-12.46l-4.48-5.84h-11.21Zm21.91 79.88a4.87 4.87 0 1 0 .001-9.74 4.87 4.87 0 0 0 0 9.74Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint1_linear_5601_1318)",
    d: "M83 88.42c0 5.65-4.58 10.23-10.23 10.23H28.94c-5.65 0-10.23-4.58-10.23-10.23V11.46c0-5.65 4.58-10.23 10.23-10.23h43.83C78.42 1.23 83 5.81 83 11.46v76.96ZM28.94 8.05c-1.88 0-3.41 1.53-3.41 3.41v76.95c0 1.88 1.53 3.41 3.41 3.41h43.83c1.88 0 3.41-1.53 3.41-3.41V11.46c0-1.88-1.53-3.41-3.41-3.41h-11.2l-4.48 5.84H44.63l-4.48-5.84H28.94Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint2_linear_5601_1318)",
    d: "M56.542 50.03a9.53 9.53 0 1 0 0-19.06 9.53 9.53 0 0 0 0 19.06Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint3_linear_5601_1318)",
    fillRule: "evenodd",
    d: "M38.45 70.82c-2.18-4.64-1.06-13.41-1.06-13.41s-12.7-21.01-6.6-23.21c5.32-1.92 4.9 8.73 10.01 13.84 2.77 2.77 4.9 4.47 11.07 4.47 9.37 0 18.31 5.17 18.31 15.35-.01 10.25-28.32 10.2-31.73 2.96Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#F4DC03",
    fillRule: "evenodd",
    d: "m30.395 30.902-.422-3.77a4.65 4.65 0 0 0-4.1-4.102l-3.775-.421c-.13-.015-.13-.203 0-.218l3.77-.421a4.65 4.65 0 0 0 4.102-4.101l.421-3.77c.015-.132.203-.132.218 0l.421 3.77a4.65 4.65 0 0 0 4.101 4.1l3.77.422c.132.015.132.203 0 .218l-3.77.421a4.65 4.65 0 0 0-4.1 4.101l-.422 3.77c-.01.132-.2.132-.214 0Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint4_radial_5601_1318)",
    fillRule: "evenodd",
    d: "m79.898 64.942-.547-4.895a6.036 6.036 0 0 0-5.324-5.324l-4.9-.547c-.17-.019-.17-.264 0-.283l4.895-.547a6.036 6.036 0 0 0 5.324-5.324l.547-4.895c.02-.17.264-.17.283 0l.547 4.895a6.036 6.036 0 0 0 5.324 5.324l4.895.547c.17.02.17.264 0 .283l-4.895.547a6.036 6.036 0 0 0-5.324 5.324l-.547 4.895c-.014.17-.26.17-.278 0Z"
  }), /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint0_linear_5601_1318",
    x1: 52.161,
    x2: 49.092,
    y1: 11.776,
    y2: 101.538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#6071EC"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#3D404D"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint1_linear_5601_1318",
    x1: 20.953,
    x2: 78.116,
    y1: 99.09,
    y2: 5.132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#4A68FB"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#81F4A9"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint2_linear_5601_1318",
    x1: 68.805,
    x2: 41.374,
    y1: 14.111,
    y2: 73.119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    offset: 0.398,
    stopColor: "#E4CEF0"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.69,
    stopColor: "#6172FD"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint3_linear_5601_1318",
    x1: 67.771,
    x2: 40.34,
    y1: 13.603,
    y2: 72.611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    offset: 0.543,
    stopColor: "#BDB2F4"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#5D6FFD"
  })), /*#__PURE__*/React.createElement(RadialGradient, {
    id: "paint4_radial_5601_1318",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(80.038 54.033) scale(11.0362)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    offset: 0.32,
    stopColor: "#F4DC03"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.623,
    stopColor: "#F4DA05"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.787,
    stopColor: "#F3D20B"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.918,
    stopColor: "#F1C415"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#EFB71F"
  }))));
};
ColoredIllustrationExperts.displayName = 'ColoredIllustrationExperts';
export default withProvisionalOverrideFromContext(ColoredIllustrationExperts);
//# sourceMappingURL=index.js.map